<template>
  <div v-if="isVisible" class="square" :style="positionStyle">
    <div v-if="hasInfo" class="info">
      <p>{{infoContent.email }}</p>
      <p>{{infoContent.phone }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneIcon',
  props: {
    bottom: {
      type: String,
      default: '15vh'
    },
    right: {
      type: String,
      default: '3vw'
    },
    backgroundImage: {
      type: String,
      required: true
    },
    infoContent: {
      type: Object,
      default: () => ({ email: '', phone: '' })
    }
  },
  computed: {
    positionStyle() {
      return {
        bottom: this.bottom,
        right: this.right,
        backgroundImage: `url(${require(`@/assets/${this.backgroundImage}`)})`
      };
    },
    hasInfo() {
      // 检查 infoContent 是否包含有效数据
      return this.infoContent.email.trim() !== '' || this.infoContent.phone.trim() !== '';
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    handleScroll() {
      const threshold = window.innerHeight * 0.3;
      this.isVisible = window.scrollY > threshold;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
.square {
  width: 40px;
  height: 40px;
  background-size: cover;
  background-position: center;
  position: fixed;
  cursor: pointer;
}

.info {
  position: absolute;
  top: 0;
  left: -250px;
  width: 0;
  height: 100px;
  background-color: #fff;
  color: #333;
  padding: 10px;
  box-sizing: border-box;
  opacity: 0;
  visibility: hidden;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.3);
}

.square:hover {
  background-color: #018fd7;
}

.square:hover .info {
  opacity: 1;
  visibility: visible;
  width: 250px;
}

.info p {
  margin: 10px 0 10px 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/PhoneIcon.vue